import { render, staticRenderFns } from "./LibraryFileItem.vue?vue&type=template&id=dd860300"
import script from "./LibraryFileItem.vue?vue&type=script&lang=js"
export * from "./LibraryFileItem.vue?vue&type=script&lang=js"
import style0 from "./LibraryFileItem.vue?vue&type=style&index=0&id=dd860300&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LibraryFileItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports